module.exports = __webpack_public_path__ + "media/loan_payments_calculator/cost_proj_btn-7c2a41d7.png";